export default class GraficoService {
  static convertToGraphData = (graph, selectedSafras) => {
    const safras = this.getXAxis(graph, selectedSafras);
    const series = this.getSeries(graph, selectedSafras);
    return {
      options: {
        chart: {
          id: "basic-bar",
        },
        xaxis: {
          categories: safras,
        },
        yaxis: [
          {
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
            },
            title: {
              text: graph.caracteristica,
            },
          },
        ],
      },
      series: series,
    };
  };

  static getXAxis = (graph, selectedSafras) => {
    return graph.agrupamentos[0].data
      .filter(( d ) => selectedSafras.length > 0 ? selectedSafras.includes( d.safra ) : true )
      .map((d) => {
        return d.safra;
      });
  };

  static getSeries = (graph, selectedSafras) => {
    let series = [];

    graph.agrupamentos.forEach((agrupamento, i) => {
      const newSeries = {
        name: agrupamento.legenda,
        data: agrupamento.data
          .filter(( d ) => selectedSafras.length > 0 ? selectedSafras.includes( d.safra ) : true )
          .map((a) => {
            return a.media;
          }),
      };

      if (i === 0) {
        newSeries.name = "Fazenda";
      }

      series.push(newSeries);
    });

    return series;
  };
}
